<div class="widget" cdkDrag appBaseWidget #bw="baseWidget" 
  [fillRemaining]="fillRemaining()" 
  [fixedSize]="fixedSize()" 
  [widgetId]="widgetId()" 
  [defaultFraction]="defaultFraction()" 
  [class.collapsed]="bw.isCollapsed()">
  <div class="widget-header" cdkDragHandle (dblclick)="bw.onHeaderDblClick()">
      <div class="widget-header__left">
        <span class="widget-title">{{ widgetTitle() }}</span>
        @if (evItems() != undefined) {
          <span class="widget-badge">
            <i class="fa-solid fa-bus-simple"></i>
            {{ evItems()!.length }}
          </span>
        }

    </div>
    <div class="widget-actions">
    </div>
  </div>

  <ng-template cdkDragPlaceholder>
    <div class="widget widget-placeholder" 
      [style.height.px]="bw.defaultHeightPx()">
      <i class="fa-solid fa-plus" aria-hidden="true"></i>
    </div>
  </ng-template>

  @if (!bw.isCollapsed()) {
    <div class="widget-content">
      @if (evItems() == undefined) {
        <places-spinner [small]="true"></places-spinner>
      } @else if (evItems()!.length === 0) {
        <span class="ev-empty">{{ 'No low SoC prognosis warnings' | translate }}</span>
      } @else {
        <div class="widget-list">
          <div class="widget-list-header ev-header">
            <span [title]="'Inventory number' | translate" class="sortable" (click)="setSort('inv')">
              <i class="fa-solid fa-bus-simple"></i>
              @if (sortCol() === 'inv') { <i [class]="'sort-icon fas fa-long-arrow-alt-up' + (sortDir() === 'desc' ? ' fa-flip-vertical' : '')"></i> }
            </span>
            <span [title]="'Route' | translate" class="sortable" (click)="setSort('route')">
              <i class="fas fa-route"></i>
              @if (sortCol() === 'route') { <i [class]="'sort-icon fas fa-long-arrow-alt-up' + (sortDir() === 'desc' ? ' fa-flip-vertical' : '')"></i> }
            </span>
            <span [title]="'Warning time' | translate" class="sortable" (click)="setSort('warn')">
              <i class="fa fa-exclamation-triangle"></i>
              @if (sortCol() === 'warn') { <i [class]="'sort-icon fas fa-long-arrow-alt-up' + (sortDir() === 'desc' ? ' fa-flip-vertical' : '')"></i> }
            </span>
            <span [title]="'Planned arrival' | translate" class="sortable" (click)="setSort('depot')">
              <i class="fas fa-home"></i>
              @if (sortCol() === 'depot') { <i [class]="'sort-icon fas fa-long-arrow-alt-up' + (sortDir() === 'desc' ? ' fa-flip-vertical' : '')"></i> }
            </span>
            <span [title]="'Soc prognosis' | translate" class="sortable" (click)="setSort('soc')">
              <i class="fas fa-battery-half"></i>
              @if (sortCol() === 'soc') { <i [class]="'sort-icon fas fa-long-arrow-alt-up' + (sortDir() === 'desc' ? ' fa-flip-vertical' : '')"></i> }
            </span>
          </div>
          @for (item of evItems()!; track item.rowId) {
            <div class="widget-list-row ev-row" [class.is-selected]="widgetState.openVehicleInventoryNumber() === item.vehicle.inventoryNumber" (click)="widgetState.openVehicle(item.vehicle.inventoryNumber)">
              <span class="col-inv">{{ item.vehicle.inventoryNumberWithoutPrefix }}</span>
              @if (item.vehicle.routeNumber) {
                <span class="col-route"><span class="widget-tag">{{ item.vehicle.routeNumber }}</span></span>
              } @else {
                <span class="col-route"></span>
              }
              <span class="col-warn">{{ item.warningTime | date: 'HH:mm' }}</span>
              <span class="col-arr">{{ item.plannedArrival | date: 'HH:mm' }}</span>
              <span class="col-battery">
                <span class="col-battery__text">
                  {{ item.vehicle.stateOfCharge?.sensorValue ?? '?' }}% →
                  @if (item.prognosisSoc != undefined && item.prognosisSoc < 0) {
                    <span class="widget-badge col-battery__prognosis-chip col-battery__prognosis-chip--negative">
                      {{ item.prognosisSoc }}%
                    </span>
                  } @else {
                    <span class="col-battery__prognosis">{{ item.prognosisSoc ?? '?' }}%</span>
                  }
                </span>
                <span class="col-battery__bar">
                  <span class="col-battery__fill"
                    [style.width.%]="item.vehicle.stateOfCharge?.sensorValue ?? 0"
                    [class.col-battery__fill--low]="(item.vehicle.stateOfCharge?.sensorValue ?? 0) < 20">
                  </span>
                </span>
              </span>
            </div>
          }
        </div>
      }
    </div>
  }

  <div class="resize-handle" (mousedown)="bw.onDragStart($event)"></div>
</div>
